'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var isBuffer = require('is-buffer');

var Shake = require('it-handshake');

var lp = require('it-length-prefixed');

module.exports = function (duplex) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var shake = Shake(duplex);
  var lpReader = lp.decode.fromReader(shake.reader, opts);
  var isDone = false;
  var W = {
    read: function () {
      var _read = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(bytes) {
        var _yield$shake$reader$n, value, done;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return shake.reader.next(bytes);

              case 2:
                _yield$shake$reader$n = _context.sent;
                value = _yield$shake$reader$n.value;
                done = _yield$shake$reader$n.done;

                if (!(done && value.length < bytes)) {
                  _context.next = 7;
                  break;
                }

                throw new Error('Couldn\'t read enough bytes');

              case 7:
                isDone = done;

                if (value) {
                  _context.next = 10;
                  break;
                }

                throw new Error('Value is null');

              case 10:
                return _context.abrupt("return", value);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function read(_x) {
        return _read.apply(this, arguments);
      }

      return read;
    }(),
    readLP: function () {
      var _readLP = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _yield$lpReader$next, value, done;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return lpReader.next();

              case 2:
                _yield$lpReader$next = _context2.sent;
                value = _yield$lpReader$next.value;
                done = _yield$lpReader$next.done;
                isDone = done;

                if (value) {
                  _context2.next = 8;
                  break;
                }

                throw new Error('Value is null');

              case 8:
                return _context2.abrupt("return", value);

              case 9:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function readLP() {
        return _readLP.apply(this, arguments);
      }

      return readLP;
    }(),
    readPB: function () {
      var _readPB = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(proto) {
        var value, buf;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return W.readLP();

              case 2:
                value = _context3.sent;

                if (value) {
                  _context3.next = 5;
                  break;
                }

                throw new Error('Value is null');

              case 5:
                // Is this a buffer?
                buf = isBuffer(value) ? value : value.slice();
                return _context3.abrupt("return", proto.decode(buf));

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function readPB(_x2) {
        return _readPB.apply(this, arguments);
      }

      return readPB;
    }(),
    write: function write(data) {
      // just write
      shake.writer.push(data);
    },
    writeLP: function writeLP(data) {
      // encode, write
      W.write(lp.encode.single(data, opts));
    },
    writePB: function writePB(data, proto) {
      // encode, writeLP
      W.writeLP(proto.encode(data));
    },
    pb: function pb(proto) {
      return {
        read: function read() {
          return W.readPB(proto);
        },
        write: function write(d) {
          return W.writePB(d, proto);
        }
      };
    },
    unwrap: function unwrap() {
      // returns vanilla duplex again, terminates all reads/writes from this object
      shake.rest();
      return shake.stream;
    }
  };
  return W;
};